// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Market Type
 * @export
 * @enum {string}
 */
export var MarketType;
(function (MarketType) {
    MarketType["Standard"] = "standard";
    MarketType["UserDefined"] = "userDefined";
    MarketType["Blended"] = "blended";
})(MarketType || (MarketType = {}));
export function MarketTypeFromJSON(json) {
    return json;
}
export function MarketTypeToJSON(value) {
    return value;
}
